var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, MenuItem, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
export const AiTextEditingMenuItem = (_a) => {
    var { startIcon, text, endIcon, isSubMenu, onClick } = _a, menuItemProps = __rest(_a, ["startIcon", "text", "endIcon", "isSubMenu", "onClick"]);
    return (_jsxs(MenuItem, Object.assign({ sx: textEditingMenuItemSxProps }, menuItemProps, { onClick: (e) => {
            e.stopPropagation();
            !!onClick && onClick(e);
        }, children: [_jsx(FontAwesomeIcon, { icon: startIcon }), _jsx(Typography, { children: text }), isSubMenu && _jsx(Box, { sx: { flexGrow: 1 } }), endIcon && _jsx(FontAwesomeIcon, { icon: endIcon })] })));
};
const textEditingMenuItemSxProps = {
    gap: "8px",
    minHeight: "auto",
    "&>svg": {
        minWidth: "20px"
    }
};
//# sourceMappingURL=AiTextEditingMenuItem.js.map